import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { isPresent, VERSION } from '@mbfab/shared'

import { envVariables } from '../lib/env'

import { getUserInfoFromLocalStorage } from './getUserInfoFromLocalStorage'

const BUGSNAG_API_KEY = envVariables.BUGSNAG_API_KEY
const userInfo = getUserInfoFromLocalStorage()
if (isPresent(BUGSNAG_API_KEY)) {
  Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
    appVersion: VERSION,
    releaseStage: envVariables.NODE_ENV,
    plugins: [new BugsnagPluginReact()],
    user: {
      id: userInfo?.id,
      name: userInfo?.name,
      email: userInfo?.email,
    },
  })
}

export const notifyBugsnag = ({
  error,
  severity,
  metadata,
}: {
  error: Error
  severity?: 'error' | 'warning' | 'info'
  metadata?: {
    key: string
    value: Record<string, string | number | undefined | Record<string, unknown>>
  }
}) => {
  const userInfo = getUserInfoFromLocalStorage()
  if (isPresent(BUGSNAG_API_KEY)) {
    // eslint-disable-next-line no-console
    console.error(`[bugsnag] not notified.`, { error, severity, metadata, userInfo })
    return
  }

  Bugsnag.notify(error, function (event) {
    event.severity = severity ?? 'error'
    if (userInfo) {
      event.setUser(userInfo.id, userInfo.email, userInfo.name)
      // event.addMetadata(`auth0`, userInfo) // 現状一緒なので不要
    }
    if (metadata !== undefined) {
      event.addMetadata(metadata.key, metadata.value)
    }
  })
}
